import { get } from './generic'

export async function verifyCompanyPayment(): Promise<{
    notifyPayment: boolean
}> {
    const res = await get('company/payment')
    return res.data.data
}
